import "../css/App.css";
import JoinGame from './JoinGame';
import CreateGame from './CreateGame';
import GamePage from './GamePage';
import GameLobby from './Gamelobby';
import ErrorMissing from './ErrorMissing';
import Game from './Game';
import Profile from './cvpage';
import Roulette from './roulette';
import PokemonRoulette from './PokemonRoulette';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

function App() {
  return (
<>
            <Router>
                <Routes>
                    <Route
                        
                        path="/"
                        element={<Roulette />}
                    />
                    <Route
                        path="/step1"
                        element={<Step1 />}
                    />
                    <Route
                        path="/step2"
                        element={<Step2 />}
                    />
                    <Route
                        path="/step3"
                        element={<Step3 />}
                    />
                    <Route
                        path="/step4"
                        element={<Step4 />}
                    />
                    <Route
                        path="/join"
                        element={<JoinGame />}
                    />
                    <Route
                        path="/create"
                        element={<CreateGame />}
                    />
                    <Route
                        path="/GamePage"
                        element={<GamePage />}
                    />
                   <Route
                        path="/GameLobby"
                        element={<GameLobby />}
                    />
                           <Route
                        path="/Game/:gameId/:playerId"
                        element={<Game />}
                    />
                    <Route
                     path="/Profile"
                        element={<Profile />}
                        />
                    <Route
                        path="/roulette"
                        element={<Roulette />}
                    />
                    <Route
                        path="/pokemon-roulette"
                        element={<PokemonRoulette />}
                    />
                    <Route
                        path="*"
                        element={<ErrorMissing/>}
                    />  
                </Routes>
            </Router>
        </>
  );
}

export default App;
